export default __webpack_public_path__ + "static/media/dd-arrow.dc6f02fb.svg";